var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNodp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_147:3948)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.49906 9.57541C3.39119 9.57541 0.578125 11.9918 0.578125 16.3796C0.578125 16.7222 0.855869 17 1.19856 17H15.7995C16.1422 17 16.42 16.7222 16.42 16.3796C16.42 11.992 13.6069 9.57541 8.49906 9.57541ZM1.84157 15.7591C2.08561 12.4785 4.32228 10.8163 8.49906 10.8163C12.6759 10.8163 14.9125 12.4785 15.1568 15.7591H1.84157Z",
    fill: "#7E7E7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.50033 0C6.15403 0 4.38477 1.80486 4.38477 4.1981C4.38477 6.66144 6.23099 8.66525 8.50033 8.66525C10.7697 8.66525 12.6159 6.66144 12.6159 4.1983C12.6159 1.80486 10.8466 0 8.50033 0ZM8.50033 7.42458C6.91511 7.42458 5.62563 5.97729 5.62563 4.1983C5.62563 2.48466 6.83466 1.24087 8.50033 1.24087C10.1393 1.24087 11.375 2.51215 11.375 4.1983C11.375 5.97729 10.0855 7.42458 8.50033 7.42458Z",
    fill: "#7E7E7E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_147:3948"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodp);
export default __webpack_public_path__ + "static/media/nodp.77bf3894.svg";
export { ForwardRef as ReactComponent };